import { takeLatest, all, takeEvery, take } from "redux-saga/effects"; // fork, take,  takeEvery, takeLeading
import { SAGA_ACTIONS } from "../../_config";

import * as userSaga from "./userSaga";
import * as facilitiesSaga from "./facilitiesSaga";
import * as assetsSaga from "./assetsSaga";
import * as commonSaga from "./commonSaga";
import * as spearPartsSaga from "./spearPartsSaga";
import * as stockAdjustmentSaga from "./stockAdjustmentSaga";
import * as cycleCountSaga from "./cycleCountSaga";
import * as depreciationSaga from "./depreciationSaga";
import * as workrequestSaga from "./workrequestSaga";
import * as workorderSaga from "./workorderSaga";
import * as checklistSaga from "./checklistSaga";
import * as sageSaga from "./sageSaga";
import * as maintenanceCalendarSaga from "./maintenanceCalendarSaga";
import * as purchaseSaga from "./purchaseSaga";
import * as purchaseOrderSaga from "./purchaseOrderSaga";
import * as receiptSaga from "./receiptSaga";
import * as vendorsSaga from "./vendorsSaga";
import * as billComSaga from "./billComSaga";
import * as dashboardSaga from "./dashboardSaga";
import { s } from "@fullcalendar/core/internal-common";

export function* sagas() {
  yield all([
    takeEvery(SAGA_ACTIONS.USER.LOGIN, userSaga.login),
    takeEvery(SAGA_ACTIONS.USER.LOGOUT, userSaga.logout),
    takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
    takeEvery(SAGA_ACTIONS.USER.FORGET_PASSWORD, userSaga.forgotPassword),
    takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword),
    takeEvery(SAGA_ACTIONS.USER.SAVE_TEAM_USER_MAPPING, userSaga.saveTeamUserMapping),
    // Register GET_ALL_API_ENDPOINTS saga
    takeEvery(SAGA_ACTIONS.USER.GET_ALL_API_ENDPOINTS, userSaga.getAllApiEndpoints),
    // Register SAVE_USER_MODULE_BUNDLE saga
    takeEvery(SAGA_ACTIONS.USER.SAVE_USER_MODULE_BUNDLE, userSaga.saveUserModuleBundle),
    takeEvery(SAGA_ACTIONS.USER.SAVE_USER_MODULE, userSaga.saveUserModule),
    takeEvery(SAGA_ACTIONS.USER.DELETE_USER_MODULE, userSaga.DeleteUserModule),
    takeEvery(SAGA_ACTIONS.USER.LoginWithPermissions, userSaga.LoginWithPermissions),
    takeEvery(SAGA_ACTIONS.USER.GET_USER_TYPE_BY_ID, userSaga.getUserTypeByID),
    takeEvery(SAGA_ACTIONS.USER.GET_USER_TYPES, userSaga.getUserTypes),
    takeEvery(SAGA_ACTIONS.USER.GET_USER_MODULES, userSaga.getUserModules),
    takeEvery(SAGA_ACTIONS.USER.GET_USER_MODULE_BY_ID, userSaga.getUserModuleByID),
    takeEvery(SAGA_ACTIONS.USER.SAVE_USER_MODULE_API_ENTITY, userSaga.saveUserModuleApiEntity),
    takeEvery(SAGA_ACTIONS.USER.SAVE_USER_TYPE, userSaga.saveUserType),
    takeEvery(SAGA_ACTIONS.USER.DELETE_USER_TYPE, userSaga.deleteUserType),
    takeEvery(SAGA_ACTIONS.USER.GET_USER, userSaga.getUser),
    takeEvery(SAGA_ACTIONS.USER.SAVE_USER, userSaga.saveUser),
    takeEvery(SAGA_ACTIONS.USER.DELETE_USER, userSaga.deleteUser),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_FACILITY_LIST,
      facilitiesSaga.GetFacilityList
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_FACILITY_MANAGER_LIST,
      facilitiesSaga.GetFacilityManagerList
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_FACILITY_DETAILS,
      facilitiesSaga.getFacilityDetails
    ),
    takeEvery(SAGA_ACTIONS.FACILITY.SAVE_FACILITY, facilitiesSaga.SaveFacility),
    takeEvery(SAGA_ACTIONS.FACILITY.SAVE_FACILITY_MASTER, facilitiesSaga.SaveFacilityMaster),
    takeEvery(SAGA_ACTIONS.FACILITY.SAVE_TEAM, facilitiesSaga.SaveTeam),
    takeEvery(SAGA_ACTIONS.FACILITY.SAVE_DEPARTMENT, facilitiesSaga.SaveDepartment),
    takeEvery(SAGA_ACTIONS.FACILITY.SAVE_SERVICE_TECH_MASTER, facilitiesSaga.SaveServiceTechMaster),

    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_LIST,
      facilitiesSaga.GetSubFacilityList
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY,
      facilitiesSaga.SaveSubFacility
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_TYPE_LIST,
      facilitiesSaga.GetSubFacilityTypeList
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY_IMAGE,
      facilitiesSaga.SaveSubFacilityImage
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.SAVE_FACILITY_IMAGE,
      facilitiesSaga.SaveFacilityImage
    ),

    takeEvery(
      SAGA_ACTIONS.FACILITY.DELETE_FACILITY,
      facilitiesSaga.DeleteFacility
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.DELETE_FACILITY_MANAGER,
      facilitiesSaga.DeleteFacilityManager
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.DELETE_SERVICE_TECH,
      facilitiesSaga.DeleteServiceTech
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_PROCESSING_FACILITY_LIST,
      facilitiesSaga.GetProcessingFacilityList
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_FACILITY_CODE,
      facilitiesSaga.getFacilityCode
    ),
    takeEvery(SAGA_ACTIONS.FACILITY.EXPORT_TO_CSV, facilitiesSaga.Exportcsv),
    takeEvery(SAGA_ACTIONS.FACILITY.EXPORT_TO_PDF, facilitiesSaga.Exportpdf),
    takeEvery(
      SAGA_ACTIONS.FACILITY.EXPORT_QR_CODE,
      facilitiesSaga.ExportQRCode
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.GET_FACILITY_ACTIVITY,
      facilitiesSaga.GetFacilityActivity
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.UPDATE_FACILITY_ACTIVITY_LOG_STATUS,
      facilitiesSaga.UpdateFacilityActivityLogStatus
    ),
    takeEvery(
      SAGA_ACTIONS.FACILITY.DELETE_FACILITY_ACTIVITY_LOG,
      facilitiesSaga.DeleteFacilityActivityLog
    ),

    takeEvery(SAGA_ACTIONS.ASSETS.NOTE_LIST, assetsSaga.GetnoteList),
    takeEvery(SAGA_ACTIONS.ASSETS.NOTE_SAVE, assetsSaga.saveNotes),
    takeEvery(SAGA_ACTIONS.ASSETS.DELETE_NOTES, assetsSaga.deleteNotes),

    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_ATTACHMENT,
      assetsSaga.GetAttachmentList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.SAVE_ASSET_ATTACHMENT,
      assetsSaga.SaveAssetAttachment
    ),
    takeEvery(SAGA_ACTIONS.ASSETS.SAVE_ASSET_IMAGE, assetsSaga.SaveAssetImage),
    takeEvery(
      SAGA_ACTIONS.ASSETS.DELETE_ASSET_ATTACHMENT,
      assetsSaga.DeleteAssetAttachment
    ),

    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_TO_CSV, assetsSaga.Exportcsv),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_TO_PDF, assetsSaga.Exportpdf),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODE, assetsSaga.ExportQrCode),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODEPNG, assetsSaga.ExportQrCodePng),

    takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSETS_LIST, assetsSaga.GetAssetsList),
    takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_NAME_BY_PARAM, assetsSaga.GetAssetNameByParam),
    takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_CODE, assetsSaga.GetAssetCode),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_CATEGORY,
      assetsSaga.GetAssetCategory
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_DEPARTMENT,
      assetsSaga.GetAssetDepartment
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_GROUPLIST,
      assetsSaga.GetAssetGroupList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_SUBGROUPLIST,
      assetsSaga.GetAssetSubGroupList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_TYPE_LIST,
      assetsSaga.GetAssetTypeList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_CLASIFICATION_LIST,
      assetsSaga.GetAssetClassificationList
    ),
    takeLatest(
      SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LIST,
      assetsSaga.GetAssetStatusList
    ),
    takeEvery(SAGA_ACTIONS.ASSETS.SAVE_ASSETS, assetsSaga.saveAssets),
    takeEvery(SAGA_ACTIONS.ASSETS.DELETE_ASSETS, assetsSaga.deleteAsset),
    takeEvery(SAGA_ACTIONS.ASSETS.UPDATE_STATUS, assetsSaga.updateStatus),

    takeEvery(SAGA_ACTIONS.ASSETS.GET_VENDOR_LIST, assetsSaga.GetvenderList),

    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_WARRANTY_LIST,
      assetsSaga.GetWarrantyList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.SAVE_ASSET_WARRANTY_ATTACHMENT,
      assetsSaga.SaveAssetWarrantyAttachment
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.WARRANTY_EXPORT_TO_XLS,
      assetsSaga.WarrantyExportToXLS
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_WARRANTY_ATTACHMENTS,
      assetsSaga.GetAssetWarrantyAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.SAVE_ASSET_WARRANTY,
      assetsSaga.SaveAssetWarranty
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.SAVE_ASSET_DETAILS,
      assetsSaga.SaveAssetDetails
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_WARRANTY_TERM_LIST,
      assetsSaga.GetWarrantyTermList
    ),

    takeEvery(
      SAGA_ACTIONS.ASSETS.MOVE_ASSET,
      assetsSaga.MoveAsset
    ),

    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_DETAILS_LIST,
      assetsSaga.GetAssetDetailsList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.DELETE_ASSET_DETAILS,
      assetsSaga.DeleteAssetDetails
    ),

    takeEvery(SAGA_ACTIONS.COMMON.GET_CITY, commonSaga.GetCityList),
    takeEvery(SAGA_ACTIONS.COMMON.GET_COUNTY, commonSaga.GetCountyList),
    takeLatest(SAGA_ACTIONS.COMMON.GET_STATE, commonSaga.GetStateList),
    takeEvery(SAGA_ACTIONS.COMMON.GET_TEAM, commonSaga.Getteam),
    //takeLatest(SAGA_ACTIONS.COMMON.GET_USER, commonSaga.GetUser),
    takeEvery(SAGA_ACTIONS.COMMON.GET_USER, commonSaga.GetUser),
    takeEvery(
      SAGA_ACTIONS.COMMON.GET_SERVICE_TECH,
      commonSaga.GetServiceTechList
    ),
    takeEvery(
      SAGA_ACTIONS.COMMON.GET_SERVICE_PROVIDER_LIST,
      commonSaga.GetServiceProviderList
    ),
    takeEvery(
      SAGA_ACTIONS.COMMON.GET_TAXES,
      commonSaga.getTaxes
    ),
    takeEvery(
      SAGA_ACTIONS.COMMON.DELETE_TEAM,
      commonSaga.DeleteTeam
    ),

    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_LIST,
      spearPartsSaga.getSpearPartsList
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_CODE,
      spearPartsSaga.getSpearPartsCode
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.SAVE_SPEAR_PARTS,
      spearPartsSaga.saveSpearParts
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.DELETE_SPEAR_PARTS,
      spearPartsSaga.deleteSpearParts
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_ATTACHMENTS,
      spearPartsSaga.getPartsAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_ATTACHMENTS,
      spearPartsSaga.savePartsAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_IMAGE,
      spearPartsSaga.savePartsImage
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.DELETE_PARTS_ATTACHMENTS,
      spearPartsSaga.deletePartsAttachments
    ),

    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_PDF,
      spearPartsSaga.exportToPdf
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_XLS,
      spearPartsSaga.exportToXls
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.EXPORT_QR_CODE,
      spearPartsSaga.ExportQRCode
    ),

    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_STATUS,
      spearPartsSaga.getPartsStatus
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_CATEGORY_LIST,
      spearPartsSaga.getSparePartsCategoryList
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_UNIT_LIST,
      spearPartsSaga.getPartsUnitList
    ),

    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_NOTES_LIST,
      spearPartsSaga.GetPartsNotesList
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_NOTES,
      spearPartsSaga.SavePartsNotes
    ),

    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.LOCATION_WISE_STOCK,
      spearPartsSaga.locationWiseStock
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.PURCHASE_HISTORY,
      spearPartsSaga.getPurchaseHistory
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.STOCK_PICKING_HISTORY,
      spearPartsSaga.getStockPickingHistory
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.STOCK_CYCLE_COUNT_HISTORY,
      spearPartsSaga.getStockCycleCountHistory
    ),
    takeEvery(
      SAGA_ACTIONS.SPEAR_PARTS.STOCK_ADJUSTMENT_HISTORY,
      spearPartsSaga.getStockAdjustmentHistory
    ),

    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.LIST,
      stockAdjustmentSaga.getStockAdjustmentList
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.SAVE,
      stockAdjustmentSaga.saveStockAdjustmentList
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.DELETE,
      stockAdjustmentSaga.deleteStockAdjustmentList
    ),

    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_TO_PDF,
      stockAdjustmentSaga.exportToPdf
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_TO_XLS,
      stockAdjustmentSaga.exportToXls
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_QR_CODE,
      stockAdjustmentSaga.ExportQRCode
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_ID,
      stockAdjustmentSaga.getStockAdjustmentCode
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_BY_ID,
      stockAdjustmentSaga.getStockAdjustmentByID
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.MOVE_STOCK,
      stockAdjustmentSaga.MoveStock
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_STOCK_TRANSACTION_REPORT,
      stockAdjustmentSaga.GetStockTransactionReport
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_TRANSACTION_REPORT_XLS,
      stockAdjustmentSaga.ExportStockTransactionReportXls
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_STOCK_ADJUSTMENT_REPORT,
      stockAdjustmentSaga.GetStockAdjustmentReport
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_XLS,
      stockAdjustmentSaga.ExportStockAdjustmentReportXls
    ),
    takeEvery(
      SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_PDF,
      stockAdjustmentSaga.ExportStockAdjustmentReportPdf
    ),

    takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_ID, cycleCountSaga.GetByID),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.GET_BY_PART_NAME,
      cycleCountSaga.GetByPartName
    ),
    takeEvery(SAGA_ACTIONS.CYCLE_COUNT.LIST, cycleCountSaga.GetList),
    takeEvery(SAGA_ACTIONS.CYCLE_COUNT.SAVE, cycleCountSaga.Save),
    takeEvery(SAGA_ACTIONS.CYCLE_COUNT.DELETE, cycleCountSaga.Delete),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_PDF,
      cycleCountSaga.ExportToPdf
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_XLS,
      cycleCountSaga.ExportToXls
    ),
    takeEvery(SAGA_ACTIONS.CYCLE_COUNT.GET_ID, cycleCountSaga.GetID),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.ADD_STOCK_PICKING,
      cycleCountSaga.AddStockPicking
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING,
      cycleCountSaga.GetStockPicking
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.STOCK_COUNT,
      cycleCountSaga.GetStockCount
    ),

    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_COUNT_PICKING,
      cycleCountSaga.GetStockPickingList
    ),

    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING_DETAILS,
      cycleCountSaga.GetStockPickingDetails
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING_BY_PART,
      cycleCountSaga.GetStockPickingByPartName
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.EXPORT_PICKING_TO_PDF,
      cycleCountSaga.ExportPickingToPDF
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.EXPORT_PICKING_TO_XLS,
      cycleCountSaga.ExportPickingToXLS
    ),
    takeLatest(
      SAGA_ACTIONS.DEPRECIATION.METHODS,
      depreciationSaga.GetDepreciationMethods
    ),
    takeLatest(
      SAGA_ACTIONS.DEPRECIATION.APPORTIONS,
      depreciationSaga.GetDepreciationApportions
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.LIST,
      depreciationSaga.GetDepreciationList
    ),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.SAVE, depreciationSaga.Save),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.DELETE, depreciationSaga.Delete),

    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_USEFUL_LIST,
      depreciationSaga.GetUsefulLifeList
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_CONVENTION_PERCENTAGE_LIST,
      depreciationSaga.GetConventionPercentageList
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_CONVENTION_TYPE_LIST,
      depreciationSaga.GetDepreciationConventionTypeList
    ),

    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_GAAP,
      depreciationSaga.GetGAAPDepreciation
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_REVALUATION_LIST,
      depreciationSaga.GetRevaluationList
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_DISPOSAL_LIST,
      depreciationSaga.GetDisposalList
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_MCARS_DEPRECIATION,
      depreciationSaga.GetMCARSDepreciation
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.SAVE_ASSET_DEPRECIATION,
      depreciationSaga.SaveAssetDepreciation
    ),

    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.VALIDATE_MARS_TRANSACTION,
      depreciationSaga.ValidateMCARSTransaction
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_ASSET_BOOK_VALUE,
      depreciationSaga.GetAssetBookValue
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.SAVE_REVALUATION,
      depreciationSaga.SaveRevaluation
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.SAVE_REVALUATION_ATTACHMENT,
      depreciationSaga.SaveRevaluationAttachment
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.GET_DISPOSAL_TYPE_LIST,
      depreciationSaga.GetDisposalTypeList
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.SAVE_DISPOSAL,
      depreciationSaga.SaveDisposal
    ),
    takeEvery(
      SAGA_ACTIONS.DEPRECIATION.SAVE_DISPOSAL_ATTACHMENT,
      depreciationSaga.SaveDisposalAttachment
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_LIST,
      workrequestSaga.GetWorkRequestList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_STATUS_LIST,
      workrequestSaga.GetStatusList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_PRIORITY_LIST,
      workrequestSaga.GetPriorityList
    ),
    takeEvery(SAGA_ACTIONS.WORK_REQUEST.GET_CODE, workrequestSaga.GetCode),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.MOVE_STATUS,
      workrequestSaga.MoveStatus
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.SAVE_WORK_REQUEST,
      workrequestSaga.SaveWorkRequest
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.UPLOAD_IMAGE,
      workrequestSaga.UploadImage
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.UPLOAD_ATTACHMENT,
      workrequestSaga.UploadAttachment
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_BY_ID,
      workrequestSaga.GetWorkRequestByID
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_ATTACHMENT,
      workrequestSaga.GetWorkRequestAttachments
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_ATTACHMENT,
      workrequestSaga.GetWorkRequestAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_IMAGES,
      workrequestSaga.GetWorkRequestImages
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST_FILES,
      workrequestSaga.DeleteWorkRequestFiles
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.SAVE_WORK_REQUEST_NOTES,
      workrequestSaga.SaveWorkRequestNotes
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST_NOTES,
      workrequestSaga.DeleteWorkRequestNotes
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_NOTES_LIST,
      workrequestSaga.GetWorkRequestNotesList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.EXPORT_PDF,
      workrequestSaga.ExportToPDF
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.EXPORT_XLS,
      workrequestSaga.ExportToXLS
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST,
      workrequestSaga.DeleteWorkRequest
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_STATUS_LIST,
      workorderSaga.GetWOStatusList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_PRIORITY_LIST,
      workorderSaga.GetWOPriorityList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_MAINTENANCE_LIST,
      workorderSaga.GetWOMaintenanceTypeList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ASSIGNMENT_TYPE_LIST,
      workorderSaga.GetWOAssignmentTypeList
    ),

    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_CODE, workorderSaga.GetWOCode),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_LIST,
      workorderSaga.GetWorkOrderList
    ),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.MOVE_STATUS, workorderSaga.MoveStatus),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_BY_ID,
      workorderSaga.GetWorkOrderByID
    ),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.EXPORT_TO_PDF, workorderSaga.ExportToPDF),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.EXPORT_TO_XLS, workorderSaga.ExportToXLS),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER,
      workorderSaga.DeleteWorkOrder
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ATTACHMENT,
      workorderSaga.GetWorkOrderAttachments
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_IMAGES,
      workorderSaga.GetWorkOrderImages
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER_FILES,
      workorderSaga.DeleteWorkOrderFiles
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.UPLOAD_IMAGE,
      workorderSaga.UploadImage
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.UPLOAD_ATTACHMENT,
      workorderSaga.UploadAttachment
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER,
      workorderSaga.SaveWorkOrder
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_TASK_DETAILS,
      workorderSaga.SaveWorkOrderTaskDetails
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_NOTE_LIST,
      workorderSaga.GetWorkOrderNotesList
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_TASK,
      workorderSaga.GetWOTasks
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION,
      workorderSaga.SaveWorkOrderCompletion
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION_ATTACHMENT,
      workorderSaga.UploadWorkOrderCompletionAttachment
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.UPDATE_WORK_ORDER_INPROGRESS,
      workorderSaga.UpdateWorkOrderInprogress
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.UPDATE_WORK_ORDER_SCHEDULE,
      workorderSaga.UpdateWorkOrderSchedule
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_ASSETS,
      workorderSaga.SaveWorkOrderAssets
    ),

    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_INVENTORY,
      workorderSaga.SaveWorkOrderInventory
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_STOCK_PICKING,
      workorderSaga.InsertStockPicking
    ),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_NOTE_SAVE, workorderSaga.SaveWorkOrderNotes),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER_NOTE, workorderSaga.DeleteWorkOrderNotes),

    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_BY_ID, workorderSaga.GetWorkOrderCompletionByID),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_ATTACHMENTS, workorderSaga.GetWorkOrderCompletionAttachments),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.RESCHEDULE_WORK_ORDER, workorderSaga.RescheduleWorkOrder),

    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_TYPES, checklistSaga.getChecklistTypes),
    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_CODE, checklistSaga.getChecklistCode),
    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_CHECKLISTS, checklistSaga.getChecklists),
    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_BY_ID, checklistSaga.getChecklistByID),
    takeEvery(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST, checklistSaga.saveChecklist),
    takeEvery(SAGA_ACTIONS.CHECKLIST.DELETE_CHECKLIST, checklistSaga.deleteChecklist),
    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_CHECKLIST_INPUT_TYPES, checklistSaga.getChecklistInputTypes),
    takeEvery(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST_TASK, checklistSaga.saveChecklistTask),
    takeEvery(SAGA_ACTIONS.CHECKLIST.SAVE_CHECKLIST_TASKS_ASSET_MAPPING, checklistSaga.saveCheckListTasksAssetMapping),
    takeEvery(SAGA_ACTIONS.CHECKLIST.GET_ASSETS_BY_CHECKLIST, checklistSaga.getAssetsByChecklist),
    takeEvery(SAGA_ACTIONS.CHECKLIST.DUPLICATE_CHECKLIST, checklistSaga.duplicateChecklist),
    takeEvery(SAGA_ACTIONS.SAGE.TEST_CONNECTION, sageSaga.CheckTestConnection),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_CONNECTION, sageSaga.SaveConnection),

    takeEvery(SAGA_ACTIONS.SAGE.SYNC_ACCOUNT_GROUPS, sageSaga.SyncAccountGroups),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_ACCOUNT, sageSaga.SyncAccount),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_FINANCIAL_BOOK, sageSaga.SyncFinancialBook),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_ITEM_GL, sageSaga.SyncItemGL),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_LOCATION, sageSaga.SyncLocation),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_DEPARTMENT, sageSaga.SyncDepartment),
    takeEvery(SAGA_ACTIONS.SAGE.SYNC_VENDOR, sageSaga.SyncVendor),

    takeEvery(SAGA_ACTIONS.SAGE.GET_SYNC_ACCOUNT_GROUPS, sageSaga.GetSyncAccountGroups),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SYNC_ACCOUNT, sageSaga.GetSyncAccount),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SYNC_FINANCIAL_BOOK, sageSaga.GetSyncFinancialBook),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SYNC_ITEM_GL, sageSaga.GetSyncItemGL),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SAGE_FACILITY_LIST, sageSaga.GetSageFacilityList),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SAGE_DEPARTMENT_LIST, sageSaga.GetSageDepartmentList),

    takeEvery(SAGA_ACTIONS.SAGE.GET_ASSET_SUB_GROUP_CODE, sageSaga.GetAssetSubGroupCode),
    takeEvery(SAGA_ACTIONS.SAGE.GET_ASSET_SUB_GROUP_LIST, sageSaga.GetAssetSubGroupList),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_ASSET_SUB_GROUP, sageSaga.SaveAssetSubGroup),
    takeEvery(SAGA_ACTIONS.SAGE.DELETE_ASSET_GROUP, sageSaga.DeleteAssetGroup),

    takeEvery(SAGA_ACTIONS.SAGE.GET_ASSET_MAPPING_LIST, sageSaga.GetAssetMappingList),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_ASSET_MAPPING, sageSaga.SaveAssetMapping),

    takeEvery(SAGA_ACTIONS.SAGE.GET_ASSET_INVENTORY_MAPPING_LIST, sageSaga.GetAssetInventoryMappingList),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_ASSET_INVENTORY_MAPPING, sageSaga.SaveAssetInventoryMapping),

    takeEvery(SAGA_ACTIONS.SAGE.GET_ASSET_OTHER_MAPPING_LIST, sageSaga.GetAssetOtherMappingList),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_ASSET_OTHER_MAPPING, sageSaga.SaveAssetOtherMapping),
    takeEvery(SAGA_ACTIONS.SAGE.SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING, sageSaga.SaveAssetGroupExpenseAccountMapping),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST, sageSaga.GetAssetGroupExpenseAccountMappingList),
    takeEvery(SAGA_ACTIONS.SAGE.GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST, sageSaga.GetUsedAccmDeprAccountList),
    takeEvery(SAGA_ACTIONS.SAGE.GET_USED_ACCOUNT_LIST, sageSaga.GetUsedAccountList),
    takeEvery(SAGA_ACTIONS.SAGE.POST_ALL, sageSaga.PostAll),
    takeEvery(SAGA_ACTIONS.SAGE.POST_ALL_STATUS, sageSaga.PostAllStatus),

    takeEvery(SAGA_ACTIONS.WORK_REQUEST.GET_LIST_FOR_KANBAN_VIEW, workrequestSaga.GetListForKanbanView),
    takeEvery(SAGA_ACTIONS.WORK_REQUEST.WORK_REQUEST_PROCESS_AUDIO, workrequestSaga.ProcessAudio),
    takeEvery(SAGA_ACTIONS.WORK_REQUEST.WORK_REQUEST_PROCESS_FEEDBACK, workrequestSaga.ProcessFeedback),



    takeEvery(SAGA_ACTIONS.SAGE.POST_ASSET_DISPOSAL_TO_SAGE, sageSaga.PostAssetDisposalToSage),
    takeEvery(SAGA_ACTIONS.SAGE.POST_ASSET_REVALUATION_TO_SAGE, sageSaga.PostAssetRevaluationToSage),
    takeEvery(SAGA_ACTIONS.SAGE.POST_ASSET_DEPRECIATION_TO_SAGE, sageSaga.PostAssetDepreciationToSage),

    takeEvery(SAGA_ACTIONS.SAGE.GET_REF_NUMBER_LIST, sageSaga.GetRefNumberList),

    takeEvery(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_ACTIVITY, workorderSaga.SaveWorkOrderTasks),
    takeEvery(SAGA_ACTIONS.SAGE.GET_DEFAULT_DATA_SYNC, sageSaga.GetDefaultDataSync),

    takeEvery(SAGA_ACTIONS.ASSETS.GET_JOURNAL_ENTRY_BY_ASSET_ID, assetsSaga.GetJournalEntryByAssetId),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.GET_CURRET_USERFUL_LIFE, depreciationSaga.GetCurrentUsefullife),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_LOG, workorderSaga.GetWorkOrderCompletionLog),
    takeEvery(SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LOG, assetsSaga.GetAssetStatusLog),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_TASK_LOG, workorderSaga.GetWorkOrderTaskLog),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_PDF, workorderSaga.GetWOTaskLogExportToPDF),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_XLS, workorderSaga.GetWOTaskLogExportToXLS),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_KANBAN_VIEW, workorderSaga.GetWorkOrderKanbanView),


    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_FREQUENCY_LIST,
      maintenanceCalendarSaga.getFrequencyList
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_CODE,
      maintenanceCalendarSaga.getSchedulerCode
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_TYPE,
      maintenanceCalendarSaga.getSchedulerType
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.SAVE_SCHEDULER,
      maintenanceCalendarSaga.saveScheduler
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_LIST,
      maintenanceCalendarSaga.getSchedulerList
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_BY_ID,
      maintenanceCalendarSaga.getSchedulerByID
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.DELETE_SCHEDULER,
      maintenanceCalendarSaga.deleteScheduler
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.UPLOAD_IMAGE,
      maintenanceCalendarSaga.uploadImage
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.UPLOAD_ATTACHMENT,
      maintenanceCalendarSaga.uploadAttachment
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_ATTACHMENTS,
      maintenanceCalendarSaga.getSchedulerAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.GET_SCHEDULER_IMAGES,
      maintenanceCalendarSaga.getSchedulerImages
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.DELETE_SCHEDULER_FILES,
      maintenanceCalendarSaga.deleteSchedulerFiles
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.EXPORT_TO_PDF,
      maintenanceCalendarSaga.exportToPDF
    ),
    takeEvery(
      SAGA_ACTIONS.MAINTENANCE_CALENDER.EXPORT_TO_XLS,
      maintenanceCalendarSaga.exportToXLS
    ),
    takeEvery(
      SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_SAVE_TASK_ATTACHMENTS,
      workorderSaga.SaveWOTaskAttachments
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSET_MOVEMENT_LOG_LIST,
      assetsSaga.GetAssetMovementLogList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.EXPORT_ASSET_REPORT_CSV,
      assetsSaga.ExportAssetReportCsv
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_ASSETS_REPORT_LIST,
      assetsSaga.GetAssetsReportList
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.CONVERT_TO_OWNED_ASSET,
      assetsSaga.ConvertToOwnedAsset
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_WORKORDER_USED_SPARE_PARTS,
      assetsSaga.GetWorkOrderUsedSpareParts
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_SPARE_PARTS_USAGE_REPORT,
      assetsSaga.GetSparePartsUsageReport
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_MTBF_REPORT,
      assetsSaga.GetMtbfReport
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_MTTR_REPORT,
      assetsSaga.GetMttrReport
    ),
    takeEvery(
      SAGA_ACTIONS.ASSETS.GET_MTTR_REPORT_FILTERS,
      assetsSaga.GetMttrReportFilters
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.GET_CODE,
      purchaseSaga.GetPurchaseRequestCode
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.GET_STATUSES,
      purchaseSaga.GetPurchaseRequestStatusList
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.GET_REQUEST_TYPES,
      purchaseSaga.GetPurchaseRequestTypeList
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.LIST,
      purchaseSaga.GetPurchaseRequestList
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.GET_REQUEST_BY_ID,
      purchaseSaga.GetPurchaseRequestListById
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.SAVE,
      purchaseSaga.SavePurchaseRequest
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.DELETE,
      purchaseSaga.DeletePurchaseRequest
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.EXPORT_TO_PDF,
      purchaseSaga.ExportPurchaseRequest
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.EXPORT_TO_XLS,
      purchaseSaga.ExportPurchaseRequestXLS

    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_REQUEST.PROCESS,
      purchaseSaga.SaveProcessPurchaseRequest
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.GET_STATUSES,
      purchaseOrderSaga.getOrderStatuses
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.SAVE_ORDER_FILE,
      purchaseOrderSaga.savePurchaseOrderFile
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.GET_CODE,
      purchaseOrderSaga.getOrderCode
    ),
    takeEvery(SAGA_ACTIONS.PURCHASE_ORDER.LIST, purchaseOrderSaga.getOrderList),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.GET_ORDER_BY_ID,
      purchaseOrderSaga.getOrderById
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.GET_FILES,
      purchaseOrderSaga.getFiles
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.GET_ORDER_TYPES,
      purchaseOrderSaga.getOrderTypes
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.SAVE,
      purchaseOrderSaga.saveOrder
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.DELETE,
      purchaseOrderSaga.deleteOrder
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.EXPORT_TO_PDF,
      purchaseOrderSaga.exportOrder
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.EXPORT_TO_XLS,
      purchaseOrderSaga.exportOrderXLS
    ),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.PROCESS,
      purchaseOrderSaga.processOrder
    ),
    takeEvery(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_CODE, receiptSaga.GetReciptCode),
    takeEvery(SAGA_ACTIONS.RECEIPT.SAVE_PURCHASE_RECEIPT, receiptSaga.SavePurchaseRecipt),
    takeEvery(SAGA_ACTIONS.RECEIPT.UPLOAD_ATTACHMENT, receiptSaga.UploadAttachment),
    takeEvery(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_LIST, receiptSaga.GetReciptList),
    takeEvery(SAGA_ACTIONS.SAGE.GET_SAGE_CONFIG, sageSaga.GetSageConfig),
    takeEvery(SAGA_ACTIONS.RECEIPT.EXPORT_TO_PDF, receiptSaga.ExportToPdf),
    takeEvery(SAGA_ACTIONS.RECEIPT.EXPORT_TO_XLS, receiptSaga.ExportToXls),
    takeEvery(SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_GET_PARTS_BY_WO_ID, workorderSaga.GetPartsByWOID),
    takeEvery(
      SAGA_ACTIONS.PURCHASE_ORDER.Save_Purchase_Order_From_PR,
      purchaseOrderSaga.SavePurchaseOrderFromPR
    ),
    takeEvery(
      SAGA_ACTIONS.CYCLE_COUNT.SAVE_STOCK_RETURN,
      cycleCountSaga.SaveStockReturn
    ),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.GET_ASSET_DEPRECIATION_LIST, depreciationSaga.GetAssetDepreciationList),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.GET_DEPRECIATION_REPORT, depreciationSaga.GetDepreciationReport),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.ALL_ASSET_DEPRECIATION_EXPORT_TO_XLS, depreciationSaga.AllAssetDepreciationExportToXLS),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.DEPRECIATION_REPORT_EXPORT_TO_XLS, depreciationSaga.ExportDepreciationReportcsv),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.GET_AUDITOR_REPORT, depreciationSaga.GetAuditorReport),
    takeEvery(SAGA_ACTIONS.DEPRECIATION.AUDITOR_REPORT_EXPORT_TO_XLS, depreciationSaga.ExportAuditorReportToXLS),
    takeEvery(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_BY_ID, receiptSaga.GetReciptByID),
    takeEvery(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_ATTACHMENTS, receiptSaga.GetReciptAttachments),

    takeEvery(SAGA_ACTIONS.VENDORS.FILTERED_SERVICE_PROVIDER_LIST, vendorsSaga.FilteredServiceProviderList),
    takeEvery(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_VENDOR_MAP, spearPartsSaga.SavePartsVendorMap),
    takeEvery(SAGA_ACTIONS.SPEAR_PARTS.DELETE_PARTS_VENDOR_MAP, spearPartsSaga.DeletePartsVendorMap),
    takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_CURRENT_STOCK_DETAILS, spearPartsSaga.getCurrentStockDetails),
    takeEvery(SAGA_ACTIONS.SPEAR_PARTS.GET_PERSONAL_STOCK_REPORT, spearPartsSaga.getPersonalStockReport),
    takeEvery(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_REPORT_TO_XLS, spearPartsSaga.exportReportToXLS),
    takeEvery(SAGA_ACTIONS.VENDORS.SAVE_VENDOR_DETAILS, vendorsSaga.SaveVendorDetails),
    takeEvery(SAGA_ACTIONS.VENDORS.GET_VENDOR_LIST, vendorsSaga.GetVendorList),
    takeEvery(SAGA_ACTIONS.VENDORS.SAVE_VENDOR_FILES, vendorsSaga.SaveVendorFiles),
    takeEvery(SAGA_ACTIONS.VENDORS.GET_VENDOR_BY_ID, vendorsSaga.GetVendorByID),
    takeEvery(SAGA_ACTIONS.VENDORS.DELETE_VENDOR, vendorsSaga.DeleteVendor),
    takeEvery(SAGA_ACTIONS.VENDORS.GET_SERVICE_TYPE, vendorsSaga.GetServiceType),
    takeEvery(SAGA_ACTIONS.VENDORS.EXPORT_TO_CSV, vendorsSaga.Exportcsv),
    takeEvery(SAGA_ACTIONS.VENDORS.EXPORT_TO_PDF, vendorsSaga.Exportpdf),
    takeEvery(SAGA_ACTIONS.VENDORS.GET_VENDOR_ATTACHMENT, vendorsSaga.GetAttachment),
    takeEvery(SAGA_ACTIONS.VENDORS.GET_VENDOR_CODE, vendorsSaga.GetVendorCode),
    takeEvery(SAGA_ACTIONS.RECEIPT.GET_PURCHASE_HISTORY_LIST, receiptSaga.GetPurchaseHistoryList),
    takeEvery(SAGA_ACTIONS.VENDORS.REDUX_FILTERED_SERVICE_PROVIDER_LIST, vendorsSaga.FilteredServiceProviderListRedux),

    // BillCom Sagas
    takeEvery(SAGA_ACTIONS.BILL_COM.TEST_CONNECTION, billComSaga.TestConnection),
    takeEvery(SAGA_ACTIONS.BILL_COM.SAVE_CONNECTION, billComSaga.SaveConnection),
    takeEvery(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_CONFIG, billComSaga.GetBillComConfig),
    takeEvery(SAGA_ACTIONS.BILL_COM.SYNC_VENDOR, billComSaga.SyncVendor),
    takeEvery(SAGA_ACTIONS.BILL_COM.SYNC_DEPARTMENT, billComSaga.SyncDepartment),
    takeEvery(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_VENDORS, billComSaga.GetBillComVendors),
    takeEvery(SAGA_ACTIONS.BILL_COM.GET_BILL_COM_DEPARTMENTS, billComSaga.GetBillComDepartments),

    // Dashboard Sagas
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_ADOPTION_DASHBOARD_COUNTS, dashboardSaga.GetAdoptionDashboardCounts),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_WORK_REQUEST_ORIGINS, dashboardSaga.GetWorkRequestOrigins),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_TASK_ORIGINS_GALLUS, dashboardSaga.GetTaskOriginsGallus),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_GROWER_TASK_ORIGINS, dashboardSaga.GetGrowerTaskOrigins),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_WR_STATUS_PIE_CHART, dashboardSaga.GetWRStatusPieChart),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_PDF, dashboardSaga.ExportWRStatusPieChartToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_XLS, dashboardSaga.ExportWRStatusPieChartToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_USER_ACTIVITY_SUMMARY, dashboardSaga.GetUserActivitySummary),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_STOCK_ADJUSTMENT_CHART, dashboardSaga.GetStockAdjustmentChart),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_INVENTORY_MOVEMENT_CHART, dashboardSaga.GetInventoryMovementChart),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_WR, dashboardSaga.GetManagerDashboardWR),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_TEAM, dashboardSaga.GetManagerDashboardTeam),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_PURCHASING, dashboardSaga.GetManagerDashboardPurchasing),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_ASSETS, dashboardSaga.GetManagerDashboardAssets),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_CLOSED_TASKS_REPORT, dashboardSaga.GetClosedTasksReport),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_UPTIME_REPORT, dashboardSaga.GetAssetsUptimeReport),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_TIME_COST_REPORT, dashboardSaga.GetAssetsTimeCostReport),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_WARRANTIES_REPORT, dashboardSaga.GetWarrantiesReport),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_LOW_STOCK_REPORT, dashboardSaga.GetLowStockReport),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_PDF, dashboardSaga.ExportAdoptionCountsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_XLS, dashboardSaga.ExportAdoptionCountsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_PDF, dashboardSaga.ExportKpiTotalWRsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_XLS, dashboardSaga.ExportKpiTotalWRsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_PDF, dashboardSaga.ExportKpiAvgTasksToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_XLS, dashboardSaga.ExportKpiAvgTasksToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_PDF, dashboardSaga.ExportKpiAvgHoursToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_XLS, dashboardSaga.ExportKpiAvgHoursToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_PDF, dashboardSaga.ExportKpiChecklistTasksToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_XLS, dashboardSaga.ExportKpiChecklistTasksToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_PDF, dashboardSaga.ExportKpiChecklistCompletionToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_XLS, dashboardSaga.ExportKpiChecklistCompletionToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_PDF, dashboardSaga.ExportWorkRequestOriginsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_XLS, dashboardSaga.ExportWorkRequestOriginsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_PDF, dashboardSaga.ExportGrowerTaskOriginsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_XLS, dashboardSaga.ExportGrowerTaskOriginsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_PDF, dashboardSaga.ExportUserActivitySummaryToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_XLS, dashboardSaga.ExportUserActivitySummaryToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_PDF, dashboardSaga.ExportStockAdjustmentChartToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_XLS, dashboardSaga.ExportStockAdjustmentChartToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_PDF, dashboardSaga.ExportInventoryMovementChartToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_XLS, dashboardSaga.ExportInventoryMovementChartToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_PDF, dashboardSaga.ExportManagerWorkRequestsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_XLS, dashboardSaga.ExportManagerWorkRequestsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_PDF, dashboardSaga.ExportManagerPurchasingToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_XLS, dashboardSaga.ExportManagerPurchasingToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_PDF, dashboardSaga.ExportTaskOriginsGallusToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_XLS, dashboardSaga.ExportTaskOriginsGallusToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY, dashboardSaga.GetManagerHoursByFacility),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_PDF, dashboardSaga.ExportManagerHoursByFacilityToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_XLS, dashboardSaga.ExportManagerHoursByFacilityToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_PDF, dashboardSaga.ExportTasksAgingPriorityToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_XLS, dashboardSaga.ExportTasksAgingPriorityToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_PDF, dashboardSaga.ExportWRByPriorityToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_XLS, dashboardSaga.ExportWRByPriorityToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_PDF, dashboardSaga.ExportTaskFunnelToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_XLS, dashboardSaga.ExportTaskFunnelToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_PDF, dashboardSaga.ExportHighPriorityWRsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_XLS, dashboardSaga.ExportHighPriorityWRsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_PDF, dashboardSaga.ExportTaskCreationTimeToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_XLS, dashboardSaga.ExportTaskCreationTimeToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_PDF, dashboardSaga.ExportTaskCompletionTimeToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_XLS, dashboardSaga.ExportTaskCompletionTimeToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_PDF, dashboardSaga.ExportCompletedTasksByEmployeeToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_XLS, dashboardSaga.ExportCompletedTasksByEmployeeToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_PDF, dashboardSaga.ExportLoggedHoursByEmployeeToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_XLS, dashboardSaga.ExportLoggedHoursByEmployeeToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_PDF, dashboardSaga.ExportPMReactiveToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_XLS, dashboardSaga.ExportPMReactiveToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_PDF, dashboardSaga.ExportPurchasingMethodToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_XLS, dashboardSaga.ExportPurchasingMethodToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_PDF, dashboardSaga.ExportPurchasingSpendToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_XLS, dashboardSaga.ExportPurchasingSpendToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_PDF, dashboardSaga.ExportGoodsOnOrderToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_XLS, dashboardSaga.ExportGoodsOnOrderToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_PDF, dashboardSaga.ExportLowInventoryToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_XLS, dashboardSaga.ExportLowInventoryToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_PDF, dashboardSaga.ExportDownAssetsToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_XLS, dashboardSaga.ExportDownAssetsToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_PDF, dashboardSaga.ExportAssetDowntimeToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_XLS, dashboardSaga.ExportAssetDowntimeToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_PDF, dashboardSaga.ExportMttrMtbfToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_XLS, dashboardSaga.ExportMttrMtbfToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_PDF, dashboardSaga.ExportReliabilityMatrixToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_XLS, dashboardSaga.ExportReliabilityMatrixToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_PDF, dashboardSaga.ExportExpiringWarrantiesToPDF),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_XLS, dashboardSaga.ExportExpiringWarrantiesToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_UPTIME_REPORT_XLS, dashboardSaga.ExportAssetsUptimeReportToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_TIME_COST_REPORT_XLS, dashboardSaga.ExportAssetsTimeCostReportToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_WARRANTIES_REPORT_XLS, dashboardSaga.ExportWarrantiesReportToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_STOCK_REPORT_XLS, dashboardSaga.ExportLowStockReportToXLS),
    takeEvery(SAGA_ACTIONS.DASHBOARD.EXPORT_CLOSED_TASKS_REPORT_XLS, dashboardSaga.ExportClosedTasksReportToXLS),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_MTTR_REPORT_XLS, assetsSaga.ExportMttrReportToXLS),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_MTBF_REPORT_XLS, assetsSaga.ExportMtbfReportToXLS),
    takeEvery(SAGA_ACTIONS.ASSETS.EXPORT_SPARE_PARTS_USAGE_REPORT_XLS, assetsSaga.ExportSparePartsUsageReportToXLS),
  ]);
}
